export const COLOR_INPUT_WIDTH_MOBILE = '2.5rem'
export const COLOR_INPUT_WIDTH_DESKTOP = '3.28125rem'
export const COLOR_INPUT_WIDTH_DESKTOP_SMALL_VARIANT = '2.375rem'
